import { map, mergeMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { PeopleService, LanguageService, ApplicationService } from '../shared/services';
import { Person } from '../shared/models';
import { Observable } from 'rxjs';

@Injectable()
export class CurrentUserResolver {
  constructor(
    private people: PeopleService,
    private language: LanguageService,
    private application: ApplicationService
  ) {}

  resolve(): Observable<Person> {
    return this.people.getCurrent().pipe(
      mergeMap((person) => {
        return this.application.getCurrent().pipe(
          mergeMap((app) => {
            return this.language.loadTranslations(person.language ? person.language : 'en').pipe(
              map((translation) => {
                return person;
              })
            );
          })
        );
      })
    );
  }
}
